import { Text } from '@mantine/core';
import { Flex, Image, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import bellEmptyState from '#/shared/assets/bell_illustration.svg';

interface EmptyPlaceholderProps {
  title: string;
  description: string;
}

export const EmptyPlaceholder = ({ title, description }: EmptyPlaceholderProps) => {
  const { t } = useTranslation();

  return (
    <Flex justify="center" align="center" my="xl">
      <Stack gap="md" justify="center" align="center" w={300}>
        <Image src={bellEmptyState} alt={t('ds:notifications.modal.empty.title')} w={126} />
        <Stack justify="center" align="center" gap={0}>
          <Text c="primary" size="lg" fw={500}>
            {title}
          </Text>
          <Text c="secondary" size="sm" ta="center">
            {description}
          </Text>
        </Stack>
      </Stack>
    </Flex>
  );
};
